import { render, staticRenderFns } from "./ManageStudent.vue?vue&type=template&id=bf4ebc24"
import script from "../../services/teacher/manage-student.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/manage-student.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports